<template>
  <div>
    <textarea id="toClipboard" class="to-clipboard" type="text" readonly></textarea>

    <v-app>
      <Banners v-if="banners.length" />
      <v-app-bar app v-if="!isIframe && !isAdminPage">
        <div class="d-flex align-center" @click="routeTo('home')">
          <v-btn text>
            <span class="mr-1">Shopdrop</span>
          </v-btn>
        </div>

        <div v-if="windowSize > 600" class="d-flex align-center" @click="routeTo('howToSave')">
          <v-btn text>
            <span class="mr-1">How to Save</span>
          </v-btn>
        </div>

        <div v-if="token" class="d-flex align-center" @click="routeTo('products')">
          <v-btn text>
            <span class="mr-1">Products</span>
          </v-btn>
        </div>

        <v-spacer></v-spacer>

        <v-btn v-if="!token" text @click="signIn">
          <span class="mr-2">Log In</span>
        </v-btn>

        <v-btn text v-if="token">
          <v-menu transition="slide-y-transition" offset-y offset-x bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" class="mr-2">Hello {{ name }}!</span>
            </template>
            <v-list>
              <v-list-item>
                <v-list-item-title class="clickable" @click="logout">Log Out</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-btn>
      </v-app-bar>

      <v-main>
        <Home />
      </v-main>
    </v-app>
  </div>
</template>

<script>
import Home from "./components/Home";
import { mapGetters, mapActions } from "vuex";
import Banners from "./components/Banners";

export default {
  name: "App",

  components: {
    Home,
    Banners,
  },

  data: () => ({
    windowSize: window.innerWidth,

    //
  }),
  computed: {
    ...mapGetters(["token", "name", "banners", "isIframe"]),
    isAdminPage() {
      return this.$route.query.isAdmin;
    },
  },
  methods: {
    ...mapActions(["logout", "addBanner"]),

    signIn() {
      this.$router.push({ path: "/signin" });
    },
    routeTo(route) {
      this.$router.push({ name: route });
    },
  },
};
</script>

<style scoped>
.height {
  width: 100vw;
  height: 100%;
}
.clickable {
  cursor: pointer;
}
.to-clipboard {
  position: absolute;
  right: -9999px;
  border: 0;
  height: 0px;
  width: 0px;
}
</style>
